/**
 * Category Subcategories Slider
 * Gestisce lo slider delle sottocategorie per categorie specifiche
 */
$(document).ready(function () {
    // Configurazione dello slider
    const SLIDER_CONFIG = {
        visible: 100, // Numero di elementi visibili
        step: 3,    // Numero di elementi da scorrere per volta
        autoHide: 3000 // Tempo in ms per nascondere le frecce
    };

    // Inizializza lo slider per le pagine categoria (non nel megamenu)
    const $categorySliders = $('.layout-category .custom-mega-submenu-slider, .custom-mega-submenu-slider').not('.st_mega_menu_container .custom-mega-submenu-slider');
    if (!$categorySliders.length) return;

    // Inizializza ogni slider trovato
    $categorySliders.each(function () {
        initCategorySubcategoriesSlider($(this));
    });

    function initCategorySubcategoriesSlider($categorySlider) {
        const $slider = $categorySlider;
        const $cardsContainer = $slider.find('.custom-mega-submenu-cards');
        const $leftArrow = $slider.find('.slider-arrow.left');
        const $rightArrow = $slider.find('.slider-arrow.right');
        const $cards = $slider.find('.custom-mega-submenu-card');

        if (!$cards.length) return;

        // Crea le frecce di scroll verticale se non esistono
        let $topArrow = $slider.find('.vertical-scroll-arrow.top');
        let $bottomArrow = $slider.find('.vertical-scroll-arrow.bottom');

        if (!$topArrow.length) {
            $topArrow = $('<button>')
                .addClass('vertical-scroll-arrow top')
                .attr('aria-label', 'Scroll su')
                .html('<i class="fto-up-open"></i>');
            $slider.append($topArrow);
        }

        if (!$bottomArrow.length) {
            $bottomArrow = $('<button>')
                .addClass('vertical-scroll-arrow bottom')
                .attr('aria-label', 'Scroll giù')
                .html('<i class="fto-down-open"></i>');
            $slider.append($bottomArrow);
        }

        // Funzione per aggiornare la visibilità delle frecce verticali
        function updateVerticalArrows() {
            const sliderElement = $slider[0];
            if (!sliderElement) return;

            // Su desktop, mostra le frecce solo se ci sono almeno 3 righe
            const isDesktop = window.innerWidth > 768;

            if (isDesktop) {
                // Calcola il numero di righe basandosi sull'altezza
                const $cardsContainer = $slider.find('.custom-mega-submenu-cards');
                const $firstCard = $cardsContainer.find('.custom-mega-submenu-card').first();

                if ($firstCard.length) {
                    // Calcola l'altezza di una riga (card + gap)
                    const cardHeight = $firstCard.outerHeight(true);
                    const containerHeight = sliderElement.clientHeight;

                    // Calcola quante righe sono visibili
                    const visibleRows = Math.floor(containerHeight / cardHeight);

                    // Calcola il numero totale di righe
                    const totalHeight = sliderElement.scrollHeight;
                    const totalRows = Math.ceil(totalHeight / cardHeight);

                    // Mostra le frecce solo se ci sono almeno 3 righe totali E c'è contenuto scrollabile
                    const hasAtLeast3Rows = totalRows >= 3;
                    const canScrollUp = sliderElement.scrollTop > 0;
                    const canScrollDown = sliderElement.scrollTop < (sliderElement.scrollHeight - sliderElement.clientHeight - 1);

                    if (hasAtLeast3Rows && (canScrollUp || canScrollDown)) {
                        $topArrow.toggleClass('visible', canScrollUp);
                        $topArrow.toggleClass('disabled', !canScrollUp);
                        $bottomArrow.toggleClass('visible', canScrollDown);
                        $bottomArrow.toggleClass('disabled', !canScrollDown);
                    } else {
                        $topArrow.removeClass('visible');
                        $bottomArrow.removeClass('visible');
                    }
                } else {
                    $topArrow.removeClass('visible');
                    $bottomArrow.removeClass('visible');
                }
            } else {
                // Su mobile, mostra sempre se c'è scroll
                const canScrollUp = sliderElement.scrollTop > 0;
                const canScrollDown = sliderElement.scrollTop < (sliderElement.scrollHeight - sliderElement.clientHeight - 1);

                $topArrow.toggleClass('visible', canScrollUp);
                $topArrow.toggleClass('disabled', !canScrollUp);
                $bottomArrow.toggleClass('visible', canScrollDown);
                $bottomArrow.toggleClass('disabled', !canScrollDown);
            }
        }

        // Gestisce il click sulla freccia su
        $topArrow.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const sliderElement = $slider[0];
            if (sliderElement) {
                const scrollAmount = sliderElement.clientHeight * 0.8;
                sliderElement.scrollBy({
                    top: -scrollAmount,
                    behavior: 'smooth'
                });
            }
        });

        // Gestisce il click sulla freccia giù
        $bottomArrow.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const sliderElement = $slider[0];
            if (sliderElement) {
                const scrollAmount = sliderElement.clientHeight * 0.8;
                sliderElement.scrollBy({
                    top: scrollAmount,
                    behavior: 'smooth'
                });
            }
        });

        // Aggiorna le frecce quando si scrolla (con debounce per performance)
        let scrollTimeout;
        $slider.on('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(updateVerticalArrows, 50);
        });

        // Aggiorna le frecce quando la finestra viene ridimensionata
        let resizeTimeout;
        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                updateVerticalArrows();
            }, 150);
        });

        // Aggiorna le frecce all'inizializzazione e dopo un breve delay per assicurarsi che il layout sia renderizzato
        setTimeout(updateVerticalArrows, 100);
        setTimeout(updateVerticalArrows, 500);

        let start = 0;
        const visible = SLIDER_CONFIG.visible;
        const totalCards = $cards.length;

        function renderSlider() {
            // Nascondi tutte le card
            $cards.hide();

            // Mostra solo le card visibili
            $cards.slice(start, start + visible).show();

            // Aggiorna stato delle frecce
            $leftArrow.prop('disabled', start === 0);
            $rightArrow.prop('disabled', start + visible >= totalCards);

            // Mostra frecce brevemente quando si aggiorna lo slider
            $leftArrow.addClass('visible');
            $rightArrow.addClass('visible');

            setTimeout(function () {
                if (!$slider.is(':hover')) {
                    $leftArrow.removeClass('visible');
                    $rightArrow.removeClass('visible');
                }
            }, SLIDER_CONFIG.autoHide);
        }

        // Gestione click freccia sinistra
        $leftArrow.on('click', function () {
            if (start > 0) {
                start = Math.max(0, start - SLIDER_CONFIG.step);
                renderSlider();
            }
        });

        // Gestione click freccia destra
        $rightArrow.on('click', function () {
            if (start + visible < totalCards) {
                start = Math.min(totalCards - visible, start + SLIDER_CONFIG.step);
                renderSlider();
            }
        });

        // Mostra frecce al hover
        $slider.on('mouseenter', function () {
            $leftArrow.addClass('visible');
            $rightArrow.addClass('visible');
        });

        $slider.on('mouseleave', function () {
            $leftArrow.removeClass('visible');
            $rightArrow.removeClass('visible');
        });

        // Supporto touch/swipe con rispetto dello scroll verticale
        let startX = 0;
        let startY = 0;
        let isDragging = false;
        let hasDirection = false;
        let isHorizontal = false;

        // Non blocchiamo lo scroll nativo su touchstart
        $slider.on('touchstart', function (e) {
            const t = e.originalEvent.touches[0];
            startX = t.clientX;
            startY = t.clientY;
            isDragging = true;
            hasDirection = false;
            isHorizontal = false;
        });

        // Sui dispositivi pointer/mouse possiamo prevenire il default
        $slider.on('mousedown', function (e) {
            startX = e.clientX;
            startY = e.clientY;
            isDragging = true;
            hasDirection = false;
            isHorizontal = false;
            e.preventDefault();
        });

        $(document).on('touchmove mousemove', function (e) {
            if (!isDragging) return;

            const point = e.type === 'touchmove' ? e.originalEvent.touches[0] : e;
            const currentX = point.clientX;
            const currentY = point.clientY;
            const diffX = currentX - startX;
            const diffY = currentY - startY;

            // Determina la direzione al primo movimento significativo
            if (!hasDirection && (Math.abs(diffX) > 10 || Math.abs(diffY) > 10)) {
                hasDirection = true;
                isHorizontal = Math.abs(diffX) > Math.abs(diffY);
            }

            // Se il gesto è verticale, non interferiamo con lo scroll
            if (hasDirection && !isHorizontal) {
                return;
            }

            // Gestione swipe orizzontale
            const diff = startX - currentX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    // Swipe sinistra - vai avanti
                    if (start + visible < totalCards) {
                        start = Math.min(totalCards - visible, start + SLIDER_CONFIG.step);
                        renderSlider();
                    }
                } else {
                    // Swipe destra - vai indietro
                    if (start > 0) {
                        start = Math.max(0, start - SLIDER_CONFIG.step);
                        renderSlider();
                    }
                }
                isDragging = false;
            }
        });

        $(document).on('touchend mouseup', function () {
            isDragging = false;
            hasDirection = false;
            isHorizontal = false;
        });

        // Inizializza lo slider
        renderSlider();

        // Aggiorna su resize della finestra
        $(window).on('resize', function () {
            // Ricalcola il numero di elementi visibili in base alla larghezza
            const containerWidth = $slider.width();
            const cardWidth = $cards.first().outerWidth(true);
            const newVisible = Math.floor(containerWidth / cardWidth);

            if (newVisible !== visible && newVisible > 0) {
                SLIDER_CONFIG.visible = newVisible;
                if (start + newVisible > totalCards) {
                    start = Math.max(0, totalCards - newVisible);
                }
                renderSlider();
            }
        });
    }
});
